import { render } from "./StepDocumenti.vue?vue&type=template&id=34e8d88b"
import script from "./StepDocumenti.vue?vue&type=script&lang=js"
export * from "./StepDocumenti.vue?vue&type=script&lang=js"

import "./StepDocumenti.vue?vue&type=style&index=0&id=34e8d88b&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__